//#region src/card_entry_method.ts
var CardEntryMethod = /* @__PURE__ */ function(CardEntryMethod) {
	CardEntryMethod[CardEntryMethod["Unknown"] = 0] = "Unknown";
	CardEntryMethod[CardEntryMethod["Swipe"] = 1] = "Swipe";
	CardEntryMethod[CardEntryMethod["Chip"] = 2] = "Chip";
	CardEntryMethod[CardEntryMethod["Contactless"] = 3] = "Contactless";
	CardEntryMethod[CardEntryMethod["ManuallyEntered"] = 4] = "ManuallyEntered";
	CardEntryMethod[CardEntryMethod["Scan"] = 5] = "Scan";
	CardEntryMethod[CardEntryMethod["ApplePay"] = 6] = "ApplePay";
	CardEntryMethod[CardEntryMethod["GooglePay"] = 7] = "GooglePay";
	CardEntryMethod[CardEntryMethod["ProvidedExternally"] = 8] = "ProvidedExternally";
	CardEntryMethod[CardEntryMethod["CardOnFile"] = 9] = "CardOnFile";
	CardEntryMethod[CardEntryMethod["Apm"] = 10] = "Apm";
	return CardEntryMethod;
}(CardEntryMethod || {});
//#endregion
export { CardEntryMethod };

//# sourceMappingURL=card_entry_method.js.map